export default __webpack_public_path__ + "static/media/telegram-logo.190f78aa.svg";